var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"assistant"}},[_c('h1',{attrs:{"id":"dost"}},[_vm._v("Dost")]),_c('img',{attrs:{"src":require('/src/assets/dost.png'),"alt":"dost","id":"bot-image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }